import { createContext, useContext, useState, useCallback } from 'react';
import { THEME_PRESETS, DEFAULT_THEME_COLOR } from '../theme/presets';

const STORAGE_KEY = 'themeColor';

function getInitialThemeColor() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored && THEME_PRESETS[stored] ? stored : DEFAULT_THEME_COLOR;
}

const SettingsContext = createContext();

function SettingsProvider({ children }) {
  const [themeColor, setThemeColorState] = useState(getInitialThemeColor);

  const setThemeColor = useCallback((color) => {
    if (!THEME_PRESETS[color]) return;
    localStorage.setItem(STORAGE_KEY, color);
    setThemeColorState(color);
  }, []);

  return (
    <SettingsContext.Provider value={{ themeColor, setThemeColor }}>{children}</SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

export default SettingsProvider;
